import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import Image from "next/image";

const Footer = () => {
  return (
    <footer className="footer-area">
      <div className="footer-widget pt-30 pb-80">
        <div className="container">
          <div className="row">
            {/* Footer Column 1 */}
            <div className="col-lg-4 col-md-6" id="footer-column-1">
              <div className="footer-about mt-50">
                <a href="/" className="logo">
                  <Image
                    src="/header/logo/stlogo.png"
                    alt="logo"
                    style={{ maxWidth: "250px" }}
                    width={250}
                    height={94}
                  />
                </a>
                <div className="p text">Our Social Media Presence</div>
                <ul className="social" style={{ paddingLeft: "0rem" }}>
                  <li>
                    <a href="https://api.whatsapp.com/send?phone=8870897752&text=Hi,%20Sarvaa!">
                      <i className="fa-brands fa-whatsapp"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/sarvaa-technologies/">
                      <i className="fa-brands fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/sarvaatechnologies/">
                      <i className="fa-brands fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/sarvaatechnologies/">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://x.com/SarvaaTech">
                    <FontAwesomeIcon icon={faXTwitter} />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Footer Column 2 */}
            <div className="col-lg-5 col-md-6" id="footer-column-2">
              <div className="footer-link d-flex flex-wrap">
                <div className="footer-link-wrapper mt-45">
                  <div className="footer-title">
                    <h4 className="title">Quick Links</h4>
                  </div>
                  <ul className="link" style={{ paddingLeft: "0rem", listStyle: "none"}}>
                    <li><a href="/">Home</a></li>
                    <li><a href="/blog">Blog</a></li>
                    <li><a href="/contact-us">Contact Us</a></li>
                  </ul>
                </div>
                <div className="footer-link-wrapper mt-45">
                  <div className="footer-title">
                    <h4 className="title">Company</h4>
                  </div>
                  <ul className="link" style={{ paddingLeft: "0rem", listStyle: "none" }}>
                    <li><a href="/about-us">About Us</a></li>
                    <li><a href="/privacy-policy">Privacy Policy</a></li>
                    <li><a href="/terms-and-conditions">Terms and Conditions</a></li>
                    {/* <li><a href="/terms-of-service">Terms of Service</a></li> */}
                  </ul>
                </div>
              </div>
            </div>

            {/* Footer Column 3 */}
            <div className="col-lg-3 col-md-6" id="footer-column-3">
              <div className="footer-contact mt-45">
                <div className="footer-title">
                  <h4 className="title">Support</h4>
                </div>
                <ul className="contact-list" style={{ paddingLeft: "0rem" , listStyle: "none"}}>
                  <li>
                    <div className="contact-info">
                      <div className="info-content media-body">
                        <p className="text">
                          <a href="tel:+918870897752">
                            <i className="fa-solid fa-phone"></i> +91 887 089 7752
                          </a>
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="contact-info">
                      <div className="info-content media-body">
                        <p className="text">
                          <a href="mailto:sales@sarvaatechnologies.com">
                            <i className="fa-regular fa-envelope"></i> sales@sarvaatechnologies.com
                          </a>
                        </p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="contact-info">
                      <div className="info-content media-body">
                        <p className="text">
                          <i className="fa-solid fa-location-dot"></i> Nagamalai Pudukkottai, Madurai-19, Tamilnadu, India.
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <div className="container">
          <div className="row-justify-content-center">
            <div className="lo-lg-12">
              <div className="copyright">
                <div className="copyright-text text-center">
                  <p className="text">
                    Copyright &#169; 2025 <a href="https://sarvaatechnologies.com">Sarvaa Technologies</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
